<template>
  <div class="d-flex align-center">
    <span>{{ getItems(items, visibleItems) }}</span>
    <v-tooltip
      v-if="items.length > visibleItems"
      max-width="600"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          class="light-grey--text more-items-avatar"
          color="bg-grey"
          size="28"
          small
          v-bind="attrs"
          v-on="on"
        >
          +{{ items.length - visibleItems }}
        </v-avatar>
      </template>
      <span>{{ getItems(items, items.length, visibleItems) }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    visibleItems: {
      type: Number,
      default: 1,
    },
    label: {
      type: String,
      default: 'name',
    },
  },
  methods: {
    getItems(items, end = items.length, start = 0) {
      return items.length ? items.map((item) => item[this.label]).slice(start, end).join(', ') : '-';
    },
  },
};
</script>

<style lang="scss" scoped>
.more-items-avatar {
  min-width: 42px !important;
  width: 42px !important;
  border-radius: 14px;
  line-height: 28px;
  margin-left: 8px;
  margin-bottom: 2px;
}
</style>
